import { useDeviceType } from '@libs/common-next';

export const whiteSpaceCalculation = (
    translate: number,
    perViewObject: number,
    gap: number,
    qytTiles: number,
    ignoreWhiteSpace?: boolean
) => {
    const width = window.innerWidth;
    const perView = (width + gap * qytTiles) / perViewObject;
    if (translate < width || ignoreWhiteSpace) {
        return translate;
    }

    const whiteSpacePerView = perView / perViewObject;

    return translate - whiteSpacePerView;
};

export const useWhiteSpaceCalculation = () => {
    const { isMobile } = useDeviceType();
    if (!isMobile) {
        return undefined;
    }
    return whiteSpaceCalculation;
};
